import { render, staticRenderFns } from "./UpdateMessage.vue?vue&type=template&id=6b725cea&"
import script from "./UpdateMessage.vue?vue&type=script&lang=js&"
export * from "./UpdateMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports